export default "__VITE_ASSET__a411d432__"